import Parse from 'parse'
import config from 'config'

Parse.initialize(config.parseApplicationId, config.parseJavascriptKey)
Parse.serverURL = '/parse/1'

export default Parse



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/modules/parse.js